import cn from './cn.json';
import en from './en.json';
export function registerI18n(i18n) {
    i18n.mergeLocaleMessage('cn', cn);
    i18n.mergeLocaleMessage('en', en);
}
